import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className={`cookie-consent ${showConsent ? 'show' : ''}`}>
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Χρησιμοποιούμε Cookies</h3>
          <p>
            Αυτός ο ιστότοπος χρησιμοποιεί cookies για να βελτιώσει την εμπειρία σας. 
            Χρησιμοποιούμε cookies για την ανάλυση της επισκεψιμότητας και τη βελτίωση 
            των υπηρεσιών μας.
          </p>
          <p>
            Για περισσότερες πληροφορίες, διαβάστε την{' '}
            <Link to="/privacy-policy">Πολιτική Απορρήτου</Link> μας.
          </p>
        </div>
        
        <div className="cookie-buttons">
          <button onClick={handleAccept} className="cookie-btn cookie-btn-accept">
            Αποδοχή Όλων
          </button>
          <button onClick={handleDecline} className="cookie-btn cookie-btn-decline">
            Απόρριψη
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;